import Features from '@ui/components/Features';
import { LazyComponent } from '@ui/components/LazyComponent';
import { useDefaultAppBar } from '@ui/components/MobileAppBarProvider';
import { InDesktop, InMobile } from '@ui/components/MobileOrDesktop';
import { SEOTemplate } from '@ui/components/SEO';
import type { NextPage } from 'next';

import { DashboardDesktop } from './DashboardDesktop';
import { DashboardMobile } from './DashboardMobile';
import { HarvestAllDrawer } from './HarvestAllDrawer/HarvestAllDrawer';
import { useHarvestAllDrawer } from './HarvestAllDrawer/useHarvestAllDrawer';

export const Dashboard: NextPage = () => {
  const isHarvestAllDrawerOpen = useHarvestAllDrawer((s) => s.isOpen);

  useDefaultAppBar();

  return (
    <>
      <SEOTemplate
        title="Dashboard - Track your LCRO earnings - Veno Finance"
        description="Track your LCRO earnings on the Veno Dashboard."
      />
      <InMobile>
        <DashboardMobile />
      </InMobile>
      <InDesktop>
        <DashboardDesktop />
      </InDesktop>
      <Features.HarvestAll>
        <LazyComponent isOpen={isHarvestAllDrawerOpen}>
          <HarvestAllDrawer />
        </LazyComponent>
      </Features.HarvestAll>
    </>
  );
};
